// test347
(347 && 0);
